// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 19351 ? "a5ce6a92" : chunkId) + "." + {"19351":"c1f7de0082641d15","19483":"ce90a3df4e198a80","38022":"07718373ebe3cb0f","53348":"bdb3fdcc4e450981","80469":"031ddf3aed134923"}[chunkId] + ".js";
};